import securityMeta from '@/router/security/securityMeta.js'

export default [
  {
    path: '/security/trade/active',
    name: 'security-trade-active',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Trade/SecurityTradeActiveView.vue'),
  },
  {
    path: '/security/trade/archive',
    name: 'security-trade-archive',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Trade/SecurityTradeArchiveView.vue'),
  },
  {
    path: '/security/trade/delete',
    name: 'security-trade-delete',
    meta: {
      ...securityMeta,
      layout: 'main-sidebar-layout',
    },
    component: () => import('@/views/Security/Trade/SecurityTradeDeleteView.vue'),
  },
]
